export function header() {
  window.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.js-header');
    if (!header) return;

    let lastScrollY = window.scrollY; // 直前のスクロール位置
    const headerHeight = header.offsetHeight; // ヘッダの高さ

    // --- 追加：タイマー管理用の変数 ---
    let isThrottling = false;

    const handleHeader = () => {
      // タイマーが作動中なら何もしない
      if (isThrottling) return;

      // フラグを立てる
      isThrottling = true;

      // 指定時間（200ms）後に実行
      setTimeout(() => {
        const currentScrollY = window.scrollY;

        // 1. 固定表示の判定 (.is-fixed)
        if (currentScrollY > headerHeight) {
          header.classList.add('is-fixed');
        } else {
          header.classList.remove('is-fixed');
        }

        // 2. 表示・非表示の判定 (.is-show / .is-hide)
        if (currentScrollY <= 0) {
          header.classList.add('is-show');
          header.classList.remove('is-hide');
        } else if (currentScrollY > lastScrollY) {
          header.classList.add('is-hide');
          header.classList.remove('is-show');
        } else {
          header.classList.add('is-show');
          header.classList.remove('is-hide');
        }

        // 現在のスクロール位置を保存
        lastScrollY = currentScrollY;

        // 処理が終わったらフラグを下ろす
        isThrottling = false;
      }, 200);
    };

    // スクロール時
    window.addEventListener('scroll', handleHeader);

    // 初期表示
    const init = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > headerHeight) {
        header.classList.add('is-fixed');
      }
      header.classList.add('is-show');
    };
    init();
  });
}